import { useState as f, useCallback as o } from "react";
function g(a = !1, i) {
  const { onOpen: e, onClose: r } = {}, [s, n] = f(a), u = o(() => {
    n((t) => t || (e == null || e(), !0));
  }, [e]), c = o(() => {
    n((t) => t && (r == null || r(), !1));
  }, [r]), l = o(() => {
    s ? c() : u();
  }, [c, u, s]);
  return [s, { open: u, close: c, toggle: l }];
}
export {
  g as u
};
